import { MappingSetKey } from "./models";

// Mapping fields config
export type FieldConfig = {
  key: string;
  label: string;
  required: boolean;
  tooltip?: string;
  sortOrder?: number;
};

export const ordersFields: FieldConfig[] = [
  { key: "customerName", label: "Customer Name", required: true, sortOrder: 1 },
  { key: "deliveryDate", label: "Delivery Date", required: true, sortOrder: 2 },
  { key: "docNumber", label: "Order Number", required: true, sortOrder: 3 },
  // { key: "address", label: "Address", required: true, sortOrder: 4 },
  {
    key: "routeName",
    label: "Route Name",
    required: false,
    sortOrder: 5,
  },
  { key: "phone", label: "Phone", required: false, sortOrder: 6 },
  { key: "email", label: "Email", required: false, sortOrder: 7 },
  {
    key: "earliestTime",
    label: "Earliest Time",
    required: false,
    sortOrder: 8,
  },
  { key: "latestTime", label: "Latest Time", required: false, sortOrder: 9 },
  {
    key: "stopTime",
    label: "Stop Time",
    required: false,
    tooltip: "How long in minutes you expect the delivery to take.",
    sortOrder: 10,
  },
  {
    key: "deliveryInstruction",
    label: "Delivery Instruction",
    required: false,
    sortOrder: 11,
  },
  {
    key: "deliveryOrder",
    label: "Delivery Order",
    required: false,
    tooltip:
      "Delivery Order should be in the sequence you want to deliver to your customers eg: 1,2,3 or you can utilise our route optimisation tool to work out the most efficient order for each route.",
    sortOrder: 12,
  },
];

export const invoicesFields: FieldConfig[] = [
  { key: "customerName", label: "Customer Name", required: true, sortOrder: 1 },
  { key: "deliveryDate", label: "Delivery Date", required: true, sortOrder: 2 },
  { key: "docNumber", label: "Invoice Number", required: true, sortOrder: 3 },
  // { key: "address", label: "Address", required: true, sortOrder: 4 },
  {
    key: "routeName",
    label: "Route Name",
    required: false,
    sortOrder: 5,
  },
  { key: "phone", label: "Phone", required: false, sortOrder: 6 },
  { key: "email", label: "Email", required: false, sortOrder: 7 },
  {
    key: "earliestTime",
    label: "Earliest Time",
    required: false,
    sortOrder: 8,
  },
  { key: "latestTime", label: "Latest Time", required: false, sortOrder: 9 },
  {
    key: "stopTime",
    label: "Stop Time",
    required: false,
    tooltip: "How long in minutes you expect the delivery to take.",
    sortOrder: 10,
  },
  {
    key: "deliveryInstruction",
    label: "Delivery Instruction",
    required: false,
    sortOrder: 11,
  },
  {
    key: "deliveryOrder",
    label: "Delivery Order",
    required: false,
    tooltip:
      "Delivery Order should be in the sequence you want to deliver to your customers eg: 1,2,3 or you can utilise our route optimisation tool to work out the most efficient order for each route.",
    sortOrder: 12,
  },
];

export const addressSingleLineFields: FieldConfig[] = [
  {
    key: "address",
    label: "Address",
    required: false,
    tooltip:
      "If address is not provided, the default delivery address of the customer will be used if it exists.",
    sortOrder: 4,
  },
];

export const addressMultiLineFields: FieldConfig[] = [
  {
    key: "addressLine1",
    label: "Address Line 1",
    required: false,
    tooltip:
      "If address is not provided, the default delivery address of the customer will be used if it exists.",
    sortOrder: 4,
  },
  {
    key: "addressLine2",
    label: "Address Line 2",
    required: false,
    sortOrder: 4.1,
  },
  { key: "suburb", label: "Suburb", required: false, sortOrder: 4.2 },
  { key: "state", label: "State", required: false, sortOrder: 4.3 },
  { key: "postcode", label: "Post Code", required: false, sortOrder: 4.4 },
  { key: "country", label: "Country", required: false, sortOrder: 4.5 },
];

export const salesFields: FieldConfig[] = [
  { key: "productSKU", label: "Product SKU", required: false, sortOrder: 20 },
  { key: "productName", label: "Product Name", required: true, sortOrder: 21 },
  { key: "quantity", label: "Quantity", required: true, sortOrder: 22 },
  {
    key: "unitOfMeasure",
    label: "Unit of Measure",
    required: false,
    sortOrder: 23,
  },
  { key: "price", label: "Price", required: true, sortOrder: 24 },
  { key: "taxCode", label: "Tax Code", required: false, sortOrder: 25 },
  {
    key: "taxPercentage",
    label: "Tax Percentage",
    required: false,
    sortOrder: 26,
  },
];

// Template file name
export const templateFiles: Record<MappingSetKey, string> = {
  importOrders: "Orders - Header Only Template.csv",
  importInvoices: "Invoices - Header Only Template.csv",
  importOrdersSales: "Orders - Header and Item Lines Template.csv",
  importInvoicesSales: "Invoices - Header and Item Lines Template.csv",
};
